import React from 'react';
import { Toaster } from 'sonner';

export default function AppToaster(props) {
  return (
    <Toaster
      position="top-right"
      richColors
      closeButton
      duration={4000}
      {...props}
    />
  );
}
